<template>
  <div style="padding-bottom: 20px">
    <div class="head">
      <h3>请填写班级信息</h3>
    </div>
    <div class="form_area">
      <el-form
        :model="classInfo"
        :rules="rules"
        ref="classInfo"
        label-width="100px"
      >
        <el-form-item label="班级名称" prop="name">
          <el-input
            v-model="classInfo.name"
            placeholder="请输入班级名称（例：21电商1班）"
          ></el-input>
        </el-form-item>
        <el-form-item label="班级封面" prop="icon">
          <el-upload
            class="uploader"
            action="#"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="(file) => upload(file, 'icon')"
          >
            <el-image
              class="upload_img"
              v-if="classInfo.icon"
              :src="classInfo.icon"
              fit="cover"
            ></el-image>
            <i v-else class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="课程选择" prop="courseId">
          <el-select
            v-model="classInfo.courseId"
            :disabled="isEdit"
            placeholder="请选择课程"
          >
            <el-option
              v-for="item in lessonList"
              :key="item.courseId"
              :label="item.title"
              :value="item.courseId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-top: 60px">
          <el-button
            class="btn"
            type="primary"
            @click="submitForm('classInfo')"
            >{{ isEdit ? "修改" : "创建" }}</el-button
          >
          <el-button class="btn" @click="resetForm('classInfo')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { courseList } from "@/api/course";
import { setClass, editClass } from "@/api/class";
import upload from "@/utils/uploadMethod";
export default {
  props: {
    currentClass: Object,
  },
  data() {
    return {
      classInfo: {
        name: "",
        icon: "",
        courseId: "",
      },
      rules: {
        name: {
          required: true,
          message: "请输入班级名称",
          trigger: "blur",
        },
        icon: {
          required: true,
          message: "请上传班级封面",
          trigger: "blur",
        },
        courseId: {
          required: true,
          message: "请选择课程",
          trigger: "blur",
        },
      },
      lessonList: [],
      isEdit: false,
      classId: null
    };
  },
  created() {
    this.getCourseList();
    if (JSON.stringify(this.currentClass) != "{}") {
      this.isEdit = true;
      this.classInfo = {
        classId: this.currentClass.classId,
        name: this.currentClass.name,
        icon: this.currentClass.icon,
        courseId: this.currentClass.courseId,
      };
    } else {
      this.isEdit = false;
    }
  },
  methods: {
    getCourseList() {
      this.$loading.show();
      courseList().then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          // console.log(res);
          this.lessonList = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    //上传图片
    async upload(file, str) {
      const fileUrl = await upload(file);
      this.classInfo[str] = fileUrl;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$loading.show();
          (this.isEdit ? editClass : setClass)(this.classInfo).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success(this.isEdit ? "修改成功" : "创建成功");
              this.classId = res.data;
              this.resetForm(formName, !this.isEdit);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName, isSet) {
      this.$refs[formName].resetFields();
      let idx = isSet ? 3 : 0;
      this.$emit("back", idx, this.classId);
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  padding: 30px;
  margin-top: 20px;
  margin-bottom: 20px;
  height: 88px;
  text-align: left;
  background-color: #fff;

  h3 {
    font-size: 20px;
  }
}

.form_area {
  padding: 80px 280px;
  margin: 0 30px;
  text-align: left;
  background-color: #fff;

  .uploader {
    width: 104px;
    height: 104px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border-color: #409eff;
    }

    .el-icon-plus {
      font-size: 28px;
      color: #8c939d;
      width: 104px;
      height: 104px;
      line-height: 104px;
      text-align: center;
    }

    .upload_img {
      width: 104px;
      height: 104px;
      display: block;
    }
  }

  .el-select {
    width: 100%;
  }

  .btn {
    width: 97px;
    height: 40px;
    border-radius: 4px;
    font-size: 16px;

    &:first-child {
      margin-right: 60px;
    }
  }
}
</style>